import {
    GET_EXISTING_MEMBER,
    SET_EXISTING_MEMBER,
    ADD_NEW_MEMBER,
    ADD_NEW_MEMBER_SUCCESS,
    ADD_NEW_MEMBER_FAILURE,
    REMOVE_MEMBERS,
    UPDATE_MEMBER,
    REMOVE_PENDING,
    SUSPEND_PROPERTY_GUEST,
    REMOVE_MEMBER_USER_SUCCESS,
    TRANSFER_MEMBER,
    TRANSFER_MEMBER_SUCCESS,
    TRANSFER_MEMBER_FAILURE,
    ADVANCE_MEMBER_QUERY,
    ADVANCE_MEMBER_QUERY_SUCCESS,
    ADVANCE_MEMBER_QUERY_FAILURE
} from './types';

export const checkingExistingMember = member => {
    return {
        type: GET_EXISTING_MEMBER,
        payload: member
    };
};

export const setExistingMember = existing => {
    return {
        type: SET_EXISTING_MEMBER,
        payload: existing
    };
};

export const addingNewMember = member => {
    return {
        type: ADD_NEW_MEMBER,
        payload: member
    };
};

export const addingNewMemberSuccess = () => {
    return {
        type: ADD_NEW_MEMBER_SUCCESS
    };
};

export const addingNewMemberFailure = error => {
    return {
        type: ADD_NEW_MEMBER_FAILURE,
        payload: error
    };
};

export const removingMember = members => {
    return {
        type: REMOVE_MEMBERS,
        payload: members
    };
};

export const removeMemberSuccess = () => {
    return {
        type: REMOVE_MEMBER_USER_SUCCESS
    };
};

export const updatingMember = member => {
    return {
        type: UPDATE_MEMBER,
        payload: member
    };
};

export const transferMember = payload => {
    return {
        type: TRANSFER_MEMBER,
        payload
    };
};

export const transferMemberSuccess = () => {
    return {
        type: TRANSFER_MEMBER_SUCCESS
    };
};

export const transferMemberFailure = error => {
    return {
        type: TRANSFER_MEMBER_FAILURE,
        payload: error
    };
};

export const removingPending = pending => {
    return {
        type: REMOVE_PENDING,
        payload: pending
    };
};

export const suspendingPropertyGuest = guest => {
    return {
        type: SUSPEND_PROPERTY_GUEST,
        payload: guest
    };
};

// export const addingNewMemberSuccess = () => {
//     return {
//         type: ADD_NEW_MEMBER_SUCCESS
//     };
// };

// export const addingNewMemberFailure = error => {
//     return {
//         type: ADD_NEW_MEMBER_FAILURE,
//         payload: error
//     };
// };

export const queryMemberData = query => {
    return {
        type: ADVANCE_MEMBER_QUERY,
        payload: query
    };
};

export const queryMemberDataSuccess = data => {
    return {
        type: ADVANCE_MEMBER_QUERY_SUCCESS,
        payload: data
    };
};

export const queryMemberDataFailure = error => {
    return {
        type: ADVANCE_MEMBER_QUERY_FAILURE,
        payload: error
    };
};
